import { Component } from 'san';
import Icon from '../icon/index.js';

/**
 * @file Button
 * @author huangxiangxiang01@baidu.com
 */
class Button extends Component {
    constructor() {
        super(...arguments);
        this.timer = null;
    }
    initData() {
        return {
            disabled: false,
            size: 'md',
            appearance: 'primary',
            _active: false
        };
    }
    click(event) {
        this.fire('click', {
            event: event,
            disabled: this.data.get('disabled')
        });
    }
    onTouchStart() {
        if (this.data.get('disabled')) {
            return;
        }
        this.data.set('_active', true);
        // 为了解决 ios 下长按按钮触发系统弹窗后 active 状态无法恢复的问题
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.data.set('_active', false);
        }, 500);
    }
    setActive(active) {
        if (this.data.get('disabled')) {
            return;
        }
        this.data.set('_active', active);
    }
    detached() {
        this.timer && clearTimeout(this.timer);
        this.timer = null;
    }
}
/* eslint-disable max-len */
Button.template = `
        <button
            class="cos-button{{
                _active ? ' cos-active' : ''}}{{
                disabled ? ' cos-disabled' : ''}}{{
                size ? ' cos-' + size : ''}}{{
                appearance ? ' cos-button-' + appearance : ''}}"
            on-click="click"
            on-touchstart="onTouchStart"
            on-touchend="setActive(false)"
            on-mousedown="setActive(true)"
            on-mouseup="setActive(false)"
        >
            <div class="cos-button-content">
                <slot></slot>
            </div>
        </button>
    `;
/* eslint-enable max-len */
Button.components = {
    'cos-icon': Icon
};

export { Button as default };
